// start:ng42.barrel
export * from './reservation-changes-summary.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/reservation-changes-summary/index.ts